export default [
  {
    name: 'Java Programmer',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Relevant',
    experience: '1-3 years',
    area: 'IT Technology',
    image: 'java.svg',
    active: false,
    content: {
      load: 'Full time, full day',
      requirements: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'git',
      ],
      conditions: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'git',
      ],
    },
  },
  {
    name: 'UI Designer',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Relevant',
    experience: '1-3 years',
    area: 'IT Technology',
    image: 'paint-palette.svg',
    active: false,
    content: {
      load: 'Full time, full day',
      requirements: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
      conditions: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
    },
  },
  {
    name: 'Cartographer',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Relevant',
    experience: '1-3 years',
    area: 'Cartography',
    image: 'career_map.svg',
    active: false,
    content: {
      load: 'Full time, full day',
      requirements: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
      conditions: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
    },
  },
  {
    name: 'Front-end Programmer',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Relevant',
    experience: '1-3 years',
    area: 'IT Technology',
    image: 'web-design.svg',
    active: false,
    content: {
      load: 'Full time, full day',
      requirements: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
      conditions: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
    },
  },
  {
    name: 'Database developer',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Relevant',
    experience: '1-3 years',
    area: 'IT Technology',
    image: 'data-storage.svg',
    active: false,
    content: {
      load: 'Full time, full day',
      requirements: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
      conditions: [
        'knowledge of C#',
        'knowledge of T-SQL',
        'knowledge of JavaScript HTML CSS',
        'knowledge of ASP.Net',
        'knowledge of NHibernate',
        'knowledge of SOAP/WSDL',
        'knowledge of .NET Core',
        'умение пользоваться git',
      ],
    },
  },
].map(it => ({
  ...it,
  image: require('@/assets/images/' + it.image),
}));
